/**
 * Extracts workspace name from the current URL pathname
 * This is a pure function that can be used in non-React contexts (like Apollo middleware)
 * @returns The workspace name from the URL, or null if not found
 */
export function getWorkspaceNameFromUrl(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const pathname = window.location.pathname
    const segments = pathname.split('/').filter(Boolean)

    // Skip if it's a user route or external route
    if (segments[0] === 'user' || pathname.includes('external')) {
      return null
    }

    // First segment after root is typically the workspace name
    return segments[0] || null
  } catch (error) {
    return null
  }
}
